import { useMutation } from '@tanstack/react-query';

import engagementUserService, { type UpdateSurveyLanguageVariables } from './engagementUserService';

export const useUpdateSurveyLanguage = () =>
    useMutation<void, Error, UpdateSurveyLanguageVariables>({
        mutationFn: (variables) => engagementUserService.updateSurveyLanguage(variables),
    });
